import { Pane } from "components/ui"
import { Text } from "@planningcenter/tapestry-react"
import { string, number, bool } from "prop-types"
import { colors } from "components/shared/admin_colors"
import InfoMessage from "./InfoMessage"

const Footer = ({ group, formsUrl, attendeeQuestionsUrl, limit, isSimpleEvent }) => {
  return (
    <Pane
      css={{
        borderRadius: "0 0 3px 3px",
        border: 0,
        borderTop: "1px solid var(--pane--border-color)"
      }}
    >
      <Pane.Body>
        <Text color={colors.neutral_030} size={14}>
          We recommend a maximum of {limit} questions so registrants can complete each section
          within the allotted time.{" "}
          <InfoMessage
            group={group}
            attendeeQuestionsUrl={attendeeQuestionsUrl}
            formsUrl={formsUrl}
            isSimpleEvent={isSimpleEvent}
          />
        </Text>
      </Pane.Body>
    </Pane>
  )
}

Footer.propTypes = {
  group: string,
  formsUrl: string,
  attendeeQuestionsUrl: string,
  limit: number,
  isSimpleEvent: bool
}

export default Footer
